export default __webpack_public_path__ + "static/media/13_Call-an-old-friend.da26e9f0.jpg";